import angular from 'angular';
import config from 'app/config';
import template from './clear-cache.tpl.html';
import './clear-cache.scss';


class ClearCacheController {
  /** @ngInject */
   constructor($rootScope) {
    this.config = config;
    this.ismobile = false;
  }
}

ClearCacheController.$inject = ["$rootScope"];

class ClearCacheComponent {
  constructor() {
    this.template = template;
    this.controller = ClearCacheController;
  }
}

export default angular
.module("clearcache.view", [])
.component("clearcache", new ClearCacheComponent())
.name;
